import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  cn,
} from '@design-system';

type ClientRelationshipStageWithUndefined = ClientRelationshipStage | 'undefined';

const relationshipStages: Record<ClientRelationshipStageWithUndefined, string> = {
  undefined: 'Undefined',
  lead: 'Lead',
  client: 'Client',
  prospect: 'Prospect',
  partner: 'Partner',
  alumni: 'Alumni',
};

const stageColorMap: Record<ClientRelationshipStageWithUndefined, string> = {
  undefined: 'bg-gray-500',
  lead: 'bg-yellow-600',
  client: 'bg-green-600',
  prospect: 'bg-blue-500',
  partner: 'bg-primary',
  alumni: 'bg-destructive',
};

interface SelectClientRelationshipProps {
  value: ClientRelationshipStage | undefined;
  onChange: (value: ClientRelationshipStage | undefined) => void;
  className?: string;
}

export function SelectClientRelationship({
  value,
  onChange,
  className,
}: SelectClientRelationshipProps) {
  const stage = value ?? 'undefined';

  function handleChange(newValue: string) {
    onChange(newValue === 'undefined' ? undefined : (newValue as ClientRelationshipStage));
  }

  return (
    <div className="flex flex-col gap-2">
      <Label>Client Relationship</Label>
      <Select
        value={stage}
        onValueChange={handleChange}
      >
        <SelectTrigger className={cn('w-full', className)}>
          <SelectValue>
            <div className="flex items-center gap-2">
              <div className={cn('size-2 shrink-0 rounded-full', stageColorMap[stage])} />
              {relationshipStages[stage]}
            </div>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="z-100">
          {Object.entries(relationshipStages).map(([stageKey, label]) => (
            <SelectItem
              key={stageKey}
              value={stageKey}
            >
              <div className="flex items-center gap-2">
                <div
                  className={cn(
                    'size-2 shrink-0 rounded-full',
                    stageColorMap[stageKey as ClientRelationshipStageWithUndefined],
                  )}
                />
                {label}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
